/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

"use client";

import React, { useRef, useState, useEffect } from "react";
import gsap from "gsap";
import { useTranslation } from "react-i18next";
import DomeGallery from "@/components/customCopmonent/DomeGallery";
import { FooterSection } from "@/components/customCopmonent/landingSection/footer-section";
import DotGrid from "@/components/customCopmonent/DotGrid";
import { Navigation } from "@/components/customCopmonent/landingSection/navigation";
import { PageShell, SectionWrapper } from "./FoundersMessage.page-primitives";
import { PageHeaderHero, PAGE_HERO_CLASS } from "@/components/customCopmonent/Text/PageHeaderHero";
import Seo from "@/components/Seo";

const Gallery = () => {
	const { t } = useTranslation();

	const pageData = {
		title: t("aboutPages.gallery.hero.title"),
		bgimage: "/images/headerPhotos/DJI202600.jpeg",

		image: "/images/ManagementPhoto/ve.jpeg",

		description: t("aboutPages.gallery.hero.tagline"),

		meta: [
			t("aboutPages.gallery.hero.meta.globalInstallations"),
			t("aboutPages.gallery.hero.meta.industrialExcellence"),
			t("aboutPages.gallery.hero.meta.engineeredForPerformance"),
		],
	};

	const [flipped, setFlipped] = useState(false);
	const [isHovered, setIsHovered] = useState(false);
	const cardRef = useRef<HTMLDivElement>(null);
	const iconRef = useRef<HTMLDivElement>(null);
	const frontCardRef = useRef<HTMLDivElement>(null);

	// GSAP hover pulse for icon
	useEffect(() => {
		if (!iconRef.current) return;

		gsap.to(iconRef.current, {
			scale: 1.2,
			repeat: -1,
			yoyo: true,
			duration: 1.2,
			ease: "power1.inOut",
		});
	}, []);

	// GSAP hover effect for the card
	useEffect(() => {
		if (!frontCardRef.current) return;

		if (isHovered && !flipped) {
			gsap.to(frontCardRef.current, {
				scale: 1.05,
				y: -10,
				duration: 0.4,
				ease: "power2.out",
				boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
			});
		} else if (!isHovered && !flipped) {
			gsap.to(frontCardRef.current, {
				scale: 1,
				y: 0,
				duration: 0.4,
				ease: "power2.out",
				boxShadow: "0 20px 25px -12px rgba(0,0,0,0.1)",
			});
		}
	}, [isHovered, flipped]);

	return (
		<PageShell>
			<Seo
				titleKey="aboutPages.gallery.seo.title"
				descriptionKey="aboutPages.gallery.seo.description"
				path="/gallery"
			/>
			<Navigation />
			{/* HEADER */}{" "}
			<SectionWrapper className={PAGE_HERO_CLASS}>
				<div className="absolute inset-0 ">
					{" "}
					<div
						className="absolute bottom-3 inset-0 opacity-35 scale-105"
						style={{
							backgroundImage: `url(${pageData.bgimage})`,
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					/>
					<DotGrid
						dotSize={4}
						gap={15}
						baseColor="#3b0092"
						activeColor="#f09a38"
						proximity={100}
						shockRadius={200}
						shockStrength={3}
						resistance={750}
						returnDuration={1.5}
					/>
				</div>
				<PageHeaderHero
					// align="center"
					title={pageData.title}
					description={pageData.description}
					meta={pageData.meta}
				/>
			</SectionWrapper>
			{/* `100vw` includes the scrollbar gutter and forced a horizontal
			    scrollbar; `100dvh` also avoids the mobile URL-bar jump that made
			    the gallery taller than the visible viewport. */}
			<div className="h-[70vh] min-h-105 w-full sm:h-[80vh] lg:h-dvh">
				<DomeGallery
					fit={0.75}
					minRadius={600}
					maxVerticalRotationDeg={0}
					segments={26}
					dragDampening={5}
					grayscale={false}
				/>
			</div>
			<FooterSection />
		</PageShell>
	);
};

export default Gallery;
